import React, { useRef } from "react";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function FormDialog({ open, board, handleModal, closeModal }) {
  const boardName = useRef();

  const handleClose = (e) => {
    e.preventDefault();
    handleModal(boardName.current.value);
  };

  return (
    <div>
      <Dialog open={open} fullWidth>
        <form onSubmit={handleClose}>
          <DialogTitle>
            <div className="font-bold"> Create Board </div>
          </DialogTitle>
          <DialogContent>
            <TextField
              inputRef={boardName}
              autoFocus
              defaultValue={board?.name}
              margin="dense"
              id="name"
              size="small"
              label="Board Name"
              fullWidth
              variant="outlined"
              required
            />
          </DialogContent>
          <DialogActions>
            <Button type='button' onClick={closeModal} variant="outlined">
              Cancel
            </Button>
            <Button type='submit' variant="contained">
              Create
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
